<template>
  <card id="evaluations" ref="evaluationref">
    <h2 slot="header" class="card-title">{{$t('reports.final_ranking')}}</h2>
    <div class="row">
      <div class="col-12">
        <div class="d-flex pull-right">
          <export-final-ranking :filters="exportFilters" class="mr-2"></export-final-ranking>
          <generate-reports></generate-reports>
        </div>
        <card card-body-classes="table-full-width">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select v-if="filtersInit" class="filter-select mr-2" v-model="filters.region" :default-first-option="true" value-key="filters.region" collapse-tags placeholder="Filter by regions" @change="handleFilters">
                  <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                </el-select>
              </div>
            </div>
            <el-table :data="applications" @sort-change="handleSort">
              <el-table-column
                sortable
                label="Final rank"
                min-width="50"
                property="final_rank"
              ></el-table-column>
              <el-table-column
                sortable
                label="Final SCORE"
                min-width="50"
                property="final_result_score"
              >
              </el-table-column>
              <el-table-column
                label="Reference"
                property="reference"
                prop="reference"
              >
                <div slot-scope="props">
                  <a class="link-text" @click="viewApplication(props.row)">{{props.row.reference}}</a>
                </div>
              </el-table-column>
              <el-table-column
                label="Title"
                property="title"
                prop="title"
              ></el-table-column>
              <el-table-column
                label="Priority Area"
                property="priority_area"
              >
              </el-table-column>
              <el-table-column
                label="Organization"
                property="organisation"
              >
              </el-table-column>
              <el-table-column
                label="Objectives"
                property="objectives"
                prop="objectives"
              >
              </el-table-column>
              <el-table-column
                label="Amount Requested"
                property="amount_requested"
              >
              </el-table-column>
              <el-table-column
                property="step_1"
              >
                <span slot="header">
                  Step I<br/>
                  <span class="font-weight-normal">Eligibility</span>
                </span>
              </el-table-column>
              <el-table-column
                property="step_2"
              >
                <span slot="header">
                  Step II<br/>
                  <span class="font-weight-normal">Due Diligence Risk</span>
                </span>
              </el-table-column>
              <el-table-column
                property="step_3"
              >
                <span slot="header">
                  Step III<br/>
                  <span class="font-weight-normal">ESMS Risk</span>
                </span>
              </el-table-column>
              <el-table-column
                property="step_4"
              >
                <span slot="header">
                  Step IV<br/>
                  <span class="font-weight-normal">Budget Review</span>
                </span>
              </el-table-column>
              <el-table-column
                property="step_5"
              >
                <span slot="header">
                  Step V<br/>
                  <span class="font-weight-normal">Technical Assessment</span>
                </span>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
              </p>
            </div>
            <base-pagination
              v-if="applications.length"
              @input="getItems"
              class="pagination-no-border"
              v-model="pagination.current_page"
              :per-page="pagination.per_page"
              :total="pagination.total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </card>
</template>
<script>
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {BasePagination, Modal, GenerateReports, ExportFinalRanking} from 'src/components';
  import {ApplicationService, ReportsService} from '@/services';

  export default {
    components: {
      GenerateReports,
      BasePagination,
      ExportFinalRanking,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Modal
    },
    computed: {
      exportFilters: function () {
        let vm = this;
        return {
          filter_region: vm.filters.region,
          filter_status: vm.filters.status
        }
      }
    },
    data() {
      return {
        initialized: false,
        filtersInit: false,
        pagination: {},
        sortColumn: undefined,
        sortOrder: undefined,
        perPage: 16,
        searchQuery: undefined,
        propsToSearch: ['reference', 'title', 'user_details.email', 'user_details.name', 'user_details.organisation_legal_name', 'region_details.name'],
        applications: [],
        filterOptions: [],
        filters: {
          status: undefined,
          countries: [],
          region: {}
        },
        evaluationTypes: [],
        modalEvaluate: {
          visibility: false,
          application: {}
        }
      };
    },
    methods: {
      async getItems(page, showLoading) {
        let vm = this;
        let page_to_get = page || vm.pagination.current_page;
        let loader;

        if (showLoading !== false) {
          loader = vm.$loading.show();
        }

        await ApplicationService.getApplications({
          page: page_to_get,
          per_page: vm.perPage,
          search: vm.searchQuery,
          sort_column: vm.sortColumn,
          sort_direction: vm.sortDirection,
          filter_region: vm.filters.region,
          filter_status: vm.filters.status,
          include_final_score_rank: 1,
          include_final_result_rank: 1,
          include_global_rank: 1,
          has_evaluations: 1,
        }).then((response) => {
          vm.pagination = response.data.meta;
          vm.applications = response.data.data;
        })

        if (showLoading !== false) {
          loader.hide();
        }
      },
      async getFilters() {
        let vm = this;
        return await ReportsService.getFilters({
          search: vm.searchQuery,
          filter_regions: vm.filters.regions,
          hide_empty_regions: 1
        }).then((response) => {
          vm.filterOptions = response.data;
        })
      },
      handleFilters() {
        let vm = this;
        vm.getItems(1);
      },
      handleSort(data) {
        let vm = this;
        let direction = null;
        if (data.order === 'ascending') {
          direction = 'asc';
        } else if (data.order === 'descending') {
          direction = 'desc';
        }
        vm.sortColumn = data.prop;
        vm.sortDirection = direction;
        vm.getItems(1);
      },
      viewApplication(application) {
        window.open('/application/fill/' + application.grant_id + '/' + application.application_id, '_blank');
      }
    },
    async created() {

    },
    async mounted() {
      let vm = this;
      let loader = vm.$loading.show();

      await vm.getFilters();
      vm.filters.region = vm.filterOptions.regions[0].value;
      vm.filters.status = 'submitted';
      vm.filtersInit = true;
      vm.sortColumn = 'final_rank';
      vm.sortDirection = 'asc';
      await vm.getItems(1, false);

      loader.hide();
    }
  };
</script>
<style lang="scss" scoped>
  .card-body {
    button {
      margin-left: 1rem;
    }
  }

  button {
    white-space: nowrap;
  }

  .evaluations-list {
    list-style-type: disc !important;
  }
</style>
